<div class="section over-hide">
    <div
            class="section padding-top-120 padding-bottom-20 padding-top-mob-nav section-background-rana "
    >
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-md-6 col-lg-5 mt-4 mt-lg-0">
                        <div
                                class="section border-4 over-hide hotel-services text-center p-3 px-xl-4"
                        >
                            <h6 class="mb-3 mt-3">
                                🌟 RANA Life Membership – Unlock Lifetime Access to Your Community 🌟
                            </h6>

                            <table class="table table-hover custom-table">
                                <tbody>
                                <tr>
                                    <td><strong>One-Time Membership Fee:</strong> $300</td>
                                </tr>
                                <tr>
                                    <td><strong>Exclusive Executive Committee Access</strong> – Shape the future of RANA
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong>Family Convention Access</strong> – Celebrate with your loved ones at
                                        special events
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong>Matrimony Platform Access</strong> – Connect and find matches within the
                                        community
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong>Chapter-Level Event Access</strong> – Network and bond locally with RANA
                                        members
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <button
                                    class="btn btn-dark-primary mt-3"
                                    (click)="payNow('life')">
                                Pay $300 – Life Membership
                            </button>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 mt-4 mt-lg-0">
                        <div
                                class="section border-4 over-hide hotel-services text-center p-3 px-xl-4"
                        >
                            <h6 class="mb-3 mt-3">
                                RANA Annual Membership – Stay Connected Year-Round
                            </h6>

                            <table class="table table-hover custom-table">
                                <tbody>
                                <tr>
                                    <td><strong>Annual Membership Fee:</strong> $50</td>
                                </tr>
                                <tr>
                                    <td><strong>Family Convention Access</strong> – Join annual gatherings with your
                                        family
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong>Chapter-Level Event Access</strong> – Participate in local RANA events
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <button
                                    class="btn btn-dark-primary mt-3"
                                    (click)="payNow('annual')">
                                Pay $50 – Annual Membership
                            </button>
                        </div>


                        <div class="section border-4 services-wrap-3 bg-teal  text-center my-3 p-3 px-xl-4"
                        >
                            <p class="mb-3">
                                Please contact the RANA National Leadership <a href="mailto:nec&#64;rajputra.org"
                                                                               style="color: yellow;font-weight: 500;">nec&#64;rajputra.org</a>
                                for payment instructions. Your membership will be activated once the payment is received
                                and processed.
                            </p>
                        </div>


                    </div>
                </div>

                <div class="row justify-content-center mt-4">
                    <div class="col-12 text-center">
                        <a
                                href="javascript:void(0)"
                                (click)="selectMembership('fm')"
                                class="btn btn-outline-secondary"
                        >
                            Skip for now</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- section
    ================================================== -->
</div>

<!-- Payment Reminder Modal -->
<div class="modal fade" id="paymentReminderModal" tabindex="-1" role="dialog"
     aria-labelledby="paymentReminderModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content section-background-24">
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="uil uil-multiply"></i>
                    </button>

                    <h5 class="mb-4 text-center">Payment Reminder</h5>

                    <div class="terms-scroll-container"
                         style="max-height: 400px; overflow-y: auto; padding-right: 15px;">
                        <div class="row">
                            <div class="col-12">
                                <h6 class="mb-3">IMPORTANT: Membership Payment Required</h6>
                                <p>To complete your registration and activate your membership, please make the
                                    appropriate payment to the RANA organization.</p>

                                <p class="mt-3">You can proceed with your registration now, but please ensure to
                                    complete the payment to fully activate your membership benefits.</p>
                            </div>
                        </div>
                    </div>

                    <div class="text-center mt-4">
                        <button (click)="completeRegistration()" type="button" class="btn btn-dark-primary">
                            Continue Registration
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>